import { Pipe } from "@angular/core";
import { AppService } from 'src/app/app.service';
// import { LiveDataService } from "src/app/live/live-data.service";

@Pipe({
    name: 'customSearchPipe',
    pure: true
})

export class CustomSearchPipe {
    constructor(
        private appService: AppService
        ){}

    transform(array: any[], searchStr: string, filteredCount: any, keys?: any[]) {
        
        if (!searchStr) {
            filteredCount['count'] = array.length;
            filteredCount['filteredList'] = array;
            this.appService.setDataToSubject(filteredCount);
            return array;
        } else {
            var filteredArr = [];
            var searchText = searchStr.toLowerCase();
            if (keys && keys.length > 0) {
                filteredArr =  array.filter(obj => {
                    for (let key of keys) {
                        // if(obj[key] && typeof(obj[key]) == "object" ){
                        //     var values = Object.values(obj[key]);
                        //     if(JSON.stringify(values).toLowerCase().includes(searchText)){
                        //         return obj;
                        //     }
                        // }
                            if (obj[key] && JSON.stringify(obj[key]).toLowerCase().includes(searchText)) {
                                return obj;
                            }
                            if(key=='hierarchyDetails'){
                                for(let key1 of array){
                                    if(key1.email && JSON.stringify(key1.email).toLowerCase().includes(searchText)){
                                        return obj;   
                                    }
                                    else if(key1.phone && JSON.stringify(key1.phone).toLowerCase().includes(searchText)){
                                        return obj;   
                                    }
                                }
                               
                            }
                   
                       
                       
                    }
                });
            } else {
                filteredArr = array.filter(obj => {
                    if (JSON.stringify(obj).toLowerCase().includes(searchText)) {
                        return obj;
                    }
                });
            }
            filteredCount['count'] = filteredArr.length;
            filteredCount['filteredList'] = filteredArr;
            this.appService.setDataToSubject(filteredCount);
            return filteredArr;

        }
    }
}
